import React from 'react';
import PropTypes from 'prop-types';
import Modal, {modalSizes} from 'components/layout/modal';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import emailApi from 'api/email';

class EmailScreenshot extends React.PureComponent {
  static displayName = 'EmailScreenshot';

  static propTypes = {
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    open: false,
    emailLink: '',
    emailBody: '',
  };

  getEmail = () => {
    emailApi.getEmail(this.props.name, this.props.intl.locale)
      .then(data => {
        const blob = new Blob([data.data], {type: 'text/html'});

        this.setState({
          emailBody: data.data,
          emailLink: URL.createObjectURL(blob),
        });
      });
  };

  open = (e) => {
    e.preventDefault();
    this.getEmail();

    this.setState({open: true});
  };

  close = () => {
    this.setState({open: false});
  };

  render() {
    return <div className='email-screenshot' style={{display: 'inline-block'}}>
      <a onClick={this.open}><FormattedMessage id="general.view" /></a>
      {this.state.open ? <Modal onClose={this.close} size={modalSizes.large}>
        <div>
          <h2 className='with-keyline'>{this.props.title}</h2>

          {this.state.emailBody ? <div className='email-screenshot__embed' dangerouslySetInnerHTML={{__html: this.state.emailBody}} /> : null}
        </div>
      </Modal> : null}
    </div>;
  }
}

export default injectIntl(EmailScreenshot);
